import React, { useCallback, useEffect } from 'react';

// תצוגת תמונה מוגדלת עם ניווט בין תמונות הגלריה (חצים, מקלדת והחלקה בטלפון)
function Lightbox({ images, index, onClose, onNavigate }) {
  const count = images.length;

  const goPrev = useCallback(() => onNavigate((index - 1 + count) % count), [index, count, onNavigate]);
  const goNext = useCallback(() => onNavigate((index + 1) % count), [index, count, onNavigate]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      // בעברית (RTL) חץ שמאלה מתקדם קדימה
      if (e.key === 'ArrowLeft') goNext();
      if (e.key === 'ArrowRight') goPrev();
    };
    window.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, goPrev, goNext]);

  useEffect(() => {
    let touchStartX = null;
    const onTouchStart = (e) => { touchStartX = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
      if (touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 50) (delta > 0 ? goNext : goPrev)();
      touchStartX = null;
    };
    window.addEventListener('touchstart', onTouchStart);
    window.addEventListener('touchend', onTouchEnd);
    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, [goPrev, goNext]);

  if (index === null || !images[index]) return null;

  return (
    <div className="lightbox" onClick={onClose} role="dialog" aria-modal="true" aria-label="תצוגת תמונה מוגדלת">
      <button type="button" className="lightbox-close" aria-label="סגירה" onClick={onClose}>
        <i className="fa fa-times"></i>
      </button>

      {count > 1 && (
        <button
          type="button"
          className="lightbox-arrow lightbox-arrow-right"
          aria-label="התמונה הקודמת"
          onClick={(e) => { e.stopPropagation(); goPrev(); }}
        >
          <i className="fa fa-chevron-right"></i>
        </button>
      )}

      <img
        src={images[index].src}
        alt={images[index].alt}
        className="lightbox-image"
        onClick={(e) => e.stopPropagation()}
      />

      {count > 1 && (
        <button
          type="button"
          className="lightbox-arrow lightbox-arrow-left"
          aria-label="התמונה הבאה"
          onClick={(e) => { e.stopPropagation(); goNext(); }}
        >
          <i className="fa fa-chevron-left"></i>
        </button>
      )}

      <div className="lightbox-counter">{index + 1} / {count}</div>
    </div>
  );
}

export default Lightbox;
